import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Utils } from 'src/app/services/utils/utils.service';
import { environment } from 'src/environments/environment';

declare let gtag: any;

// singleton service - don't include it in any component's providers []
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    isAnalyticsEnabled = false;

    constructor(private cookieService: CookieService, private utils: Utils) {
        this.utils.log('AnalyticsService.constructor');
    }

    addPageView(url: string): void {
        if (environment.brand == 'audi' && this.cookieService.get('ecmp_allowAnalytics')) {
            try {
                this.enableAnalytics();
                this.utils.log('addPageView', url);
                if (this.isAnalyticsEnabled) {
                    gtag('config', environment.googleAnalyticsId, { 'page_path': url });
                }
            } catch (error) {
                this.utils.log('addPageView', error);
            }
        }
    }

    enableAnalytics(): void {
        if (this.isAnalyticsEnabled) {
            return;
        }

        try {
            this.utils.log('Enabling Google Analytics');
            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.googleAnalyticsId;
            document.head.prepend(script);
            this.isAnalyticsEnabled = true;
        } catch (error) {
            this.utils.log('enableAnalytics', error);
        }
    }
}
